export default __webpack_public_path__ + "static/media/service-thumb-asphalt-driveway.10cdd5aa.jpg";